export default __webpack_public_path__ + "static/media/duke_pfp.fa1f901f.png";